import { Api, ErrorHandlerFunction, LogManager, ModelRow, Navigation, ServerError, StringUtil, UrlUtil } from "@mcleod/core";
import { DataSourceMode, Snackbar, TableRow, Toast } from "@mcleod/components";
import { AutogenLayoutNewOffer } from "./autogen/AutogenLayoutNewOffer";
import { CommonDialogs } from "@mcleod/common";

const log = LogManager.getLogger("portal-carrier/NewOffer");

export class NewOffer extends AutogenLayoutNewOffer {
    private replyToEmail: string;

    override async onLoad() {
        const props = UrlUtil.getPropsFromUrl(document.location.search);
        if (!StringUtil.isEmptyString(props.token)) {
            this.replyToEmail = props.replyTo;
            this.mainDataSource.search({ token: props.token, order_id: props.orderID, movement_id: props.movementID, sent_to_email: props.sentToEmail, sent_to_name: props.sentToName }, this._errorHandler).then(response => {
                if (response?.modelRows?.length > 0) {
                    this.sourceCarrierAvailableOrders.search({ type: "new", token: props.token, orderid: props.orderID }, this._errorHandler).then(response => {
                        if (response?.modelRows?.length > 0) {
                            this.panelAvailable.visible = true;
                        }
                        else {
                            this.displayNotAvailable();
                        }
                    });
                }
                else {
                    this.displayNotAvailable();
                }
            });
        } else {
            this.displayNotAvailable();
        }
        this.mainDataSource.mode = DataSourceMode.NONE;
    }

    displayNotAvailable() {
        this.panelNotAvailable.visible = true;
        this.panelAvailable.visible = false;
    }

   async buttonMakeOfferOnClick() {
        const counterAmount = this.activeRow.getCurrency("counter_amount");
        if (this.textboxCounterAmount.validateSimple(true, true) && counterAmount?.amount > 0) {
            const props = UrlUtil.getPropsFromUrl(document.location.search);
            if (!StringUtil.isEmptyString(props.token)) {
                this.buttonMakeOffer.busy = true;
                this.mainDataSource.activeRow.set("counter_offer", counterAmount)
                this.mainDataSource.activeRow.set("token", props.token)
                this.counterOffer(this.mainDataSource.activeRow).then(() => {
                    this.buttonMakeOffer.busy = false;
                });
            }
        } else {
            Snackbar.showWarningSnackbar("Counter amount must be a valid amount greater than 0.");
        }
    }

    async counterOffer(modelRow: ModelRow)  {
            const offer = this.createOfferCopy(modelRow);
            await Api.post(offer._modelPath, offer).then(response => {
                if (response?.data?.length > 0) {
                    Toast.showSuccessToast(response.data[0].message);
                    this.panelAvailable.visible = false;
                    this.panelSuccess.visible = true;
                }
            }).catch((err: ServerError) => {
                log.error(err.messages.join(", "));
                CommonDialogs.showError(err.messages[0])
            });
    }

    createOfferCopy(modelRow: ModelRow): ModelRow {
        const offer = modelRow.createBasicCopy();
        offer._appending = true;
        offer.set("reply_to", this.replyToEmail);
        offer.set("id", null);
        return offer;
    }

    _errorHandler: ErrorHandlerFunction = (error) => {
        Navigation.navigateTo("");
    }

}
